import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue } from 'src/lib/validation/ValidationTypes';
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';
import PruefAssistenz from '../../../../../antrag-components/PruefAssistenz';
import ApplicationHeading from '../../../../../application-heading/ApplicationHeading';
import { checkIfPruefAssitenzNeedsToValidate } from '../../../../../application-helper-function/AppHelperfunctions';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

const BeschaffungEinerWasserstoffAntragEbusseNachruestung: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);
	return (
		<>
			<ApplicationHeading title='Beschaffung einer Wasserstoff-Betankungsanlage' description={PLATZHALTER_TEXT} />
			<PruefAssistenz
				statusPath={P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Wasserstoff_Nachruestung_Pruefstatus.path}
				hinweisPath={P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Wasserstoff_Nachruestung_Hinweis_Antragsteller.path}
				ueberarbeitetAmPath={P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Wasserstoff_Nachruestung_Ueberarbeitet_Am.path}
				erledigtPath={P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Wasserstoff_Nachruestung_Erledigt.path}
				formStruc={formStrucPruefAssistenz()}
			/>
			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={updatedReadOnly} />
		</>
	);
};

export default BeschaffungEinerWasserstoffAntragEbusseNachruestung;

const formStrucPruefAssistenz = () => {
	// autofold/fold_next
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Wasserstoff_Nachruestung_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};
const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Projektbeschreibung_Elektrobusse.schema.attributes.Projektbeschreibung_Elek_0178575685_Wasserstoff_Betankungsanlage,
				P.Projektbeschreibung_Elektrobusse.schema.attributes.Projektbeschreibung_Elek_0145801363_schreibung_Des_Aufstellortes,
				P.Projektbeschreibung_Elektrobusse.schema.attributes.Projektbeschreibung_Elek_0218942595_bung_Von_Eigenleistungen_Etc,
				P.Projektbeschreibung_Elektrobusse.schema.attributes.Projektbeschreibung_Elek_0212325698_en_Wasserstoff_Infrastruktur,
				P.Projektbeschreibung_Elektrobusse.schema.attributes.Projektbeschreibung_Elek_0110763653_toffs_Belieferungsintervalle,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucBeschaffungEinerWasserstoffAntragEbusseNachruestung = (application: any) => {
	if (
		checkIfPruefAssitenzNeedsToValidate(
			application,
			P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Wasserstoff_Nachruestung_Pruefstatus.path,
			P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Wasserstoff_Nachruestung_Erledigt.path,
		)
	)
		return concat(formStrucPruefAssistenz(), formStruc());
	return concat(formStruc());
};
